import {
  isMonitoringSessionProcessingStatus,
  isMonitoringSessionType,
} from '../../../../../../components/MonitoringAgent/utils/monitoringSessionFlowUtils';
import { VALUE_CHAIN_AI_AGENT } from '../../../../../../constants/general';
import {
  isAIAgentSessionReviewReadyStatus,
  isVcAgentBomSocketProcessingStatus,
} from '../../../../../../utils/AICreatorHelper';

import type ISessionVCItem from '../../../../../../store/slices/valueChainMap/interfaces/ISessionVCItem';

export const isDraftReviewReadyStatus = (status?: string): boolean => (
  isAIAgentSessionReviewReadyStatus(status)
);

export const isRestorableAIGeneratingSession = (sessionItem: ISessionVCItem): boolean => (
  sessionItem.subType === VALUE_CHAIN_AI_AGENT.BILL_OF_MATERIALS_SESSION_TYPE
  || sessionItem.subType === VALUE_CHAIN_AI_AGENT.SUPPLIER_DISCOVERY_SESSION_TYPE
);

export const hasAgentSessionProcessingStatus = (sessionItem: ISessionVCItem): boolean => {
  const isSessionProcessing = isMonitoringSessionType(sessionItem.type)
    ? isMonitoringSessionProcessingStatus(sessionItem.status)
    : isVcAgentBomSocketProcessingStatus(sessionItem.status);

  return isSessionProcessing
    || sessionItem.selectedUnits?.some((selectedUnit) => (
      isVcAgentBomSocketProcessingStatus(selectedUnit.status)
    )) || false;
};
